import { Img } from "@vixi/ui";
import KnowledgeSourceHeader from "../KnowledgeSourceHeader";

// Assets
import book from "@assets/Ebooks.png";

const EbookHeader = () => {
  return (
    <KnowledgeSourceHeader
      title="CreateCourse.EbookHeaderTitle"
      subtitle="CreateCourse.EbookHeaderSubtitle"
      sourceIcon={<Img src={book} className="h-30.75" />}
    />
  );
};

export default EbookHeader;
